<template>
  <div class="Schedule">
    <h2>CHIME VLBI Calibrator Schedule</h2>
    <b-container fluid>
      <!-- User Interface controls -->
      <!--<b-button size="sm" @click.stop="addSource($event.target)" class="mr-2">
        Add New Source
      </b-button>-->
      <!--<b-button size="sm" @click.stop="selectParameters()" class="mr-1">
        Select Display Parameters
      </b-button>-->
      <b-row>
        <b-col md="3">
        </b-col>
        <b-col md="7">
          <div v-for="outrigger in outriggerItems" v-bind:key="outrigger.outrigger_id">
          <table style="border:2px solid black; color:green">
            <tr>
              <td align="left"><b>Outrigger: </b></td>
              <td align="left"><b>{{outrigger['outrigger_id']}}</b></td>
            </tr>
            <tr>
              <td align="left"><b>Operational Status: </b></td>
              <td align="left"><b>{{outrigger['operational_status']}}</b></td>
            </tr>
            <tr>
              <td align="left"><b>Beam Rows: </b></td>
              <td align="left">
                <b>
                  <!-- eslint-disable-next-line-->
                  {{ outrigger['beam_numbers'].filter(item => item < 1000) }}
                </b>
              </td>
            </tr>
            <tr>
              <td align="left"><b>URL: </b></td>
              <td align="left"><b>{{outrigger['url']}}</b></td>
            </tr>
            <tr>
              <td align="left"><b>Last Packet Received: </b></td>
              <td align="left"><b>{{ Math.floor(Date.now() / 1000) - outrigger[0]['received_time'] }} seconds ago</b></td>
            </tr>
          </table>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="4" class="my-1">
          <b-form-group horizontal label="Filter" class="mb-0">
            <b-input-group>
              <b-form-input v-model="filter" placeholder="Type to Search" />
              <b-input-group-append>
                <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="4" class="my-1">
          <b-form-group horizontal label="Per page" class="mb-0">
            <b-form-select :options="pageOptions" v-model="perPage" />
          </b-form-group>
        </b-col>
        <b-col md="4" class="my-1">
          <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" />
        </b-col>
      </b-row>

      <!-- Main table element -->
      <b-table show-empty
               :items="items"
               :fields="fields"
               :small="smallTable"
               :current-page="currentPage"
               :per-page="perPage"
               :filter="filter"
               :sort-by.sync="sortBy"
               :sort-desc.sync="sortDesc"
               :sort-direction="sortDirection"
               @filtered="onFiltered"
      >
        <template slot="source" slot-scope="row">{{row.value.first}} {{row.value.last}}</template>
        <template slot="isActive" slot-scope="row">{{row.value?'Yes :)':'No :('}}</template>
        <template slot="actions" slot-scope="row">
          <!-- We use @click.stop here to prevent a 'row-clicked' event from also happening -->
          <!--<b-button size="sm" @click.stop="deleteSource(row.item, $event.target)" class="mr-1">
            Delete
          </b-button>-->
          <b-button size="sm" @click.stop="showSource(row.item, row.index, $event.target)" class="mr-1">
            Details
          </b-button>
        </template>
        <template slot="row-details" slot-scope="row">
          <b-card>
            <ul>
              <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value}}</li>
            </ul>
          </b-card>
        </template>
      </b-table>

      <b-row>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { AuthVerificationMixin } from '../mixins/auth_mixin.js'
var baseUrl = 'https://frb.chimenet.ca/frb-master/'
var items = []
var fields = [
  {key: 'name', label: 'Name', sortable: true, 'class': 'text-center'},
  {key: 'transit_in', label: 'Transit In (sec)', sortable: true, 'class': 'text-center'},
  {key: 'beam', label: 'Beam Row', sortable: true, 'class': 'text-center'},
  {key: 'ra', label: 'RA', sortable: true, 'class': 'text-center'},
  {key: 'dec', label: 'Dec', sortable: true, 'class': 'text-center'},
  {key: 'unix_utc_start', label: 'Unix Start', sortable: true, 'class': 'text-center'},
  {key: 'actions', label: 'Actions'}
]
export default {
  mixins: [AuthVerificationMixin],
  data () {
    return {
      items: [],
      outriggerItems: [],
      fields: fields,
      fieldtitle: 'Select Parameters to Display',
      smallTable: true,
      dark: false,
      fixed: true,
      currentPage: 1,
      perPage: 5,
      totalRows: items.length,
      pageOptions: [ 5, 10, 15, 50, 100 ],
      sortBy: 'transit_in',
      plot: null,
      sortDesc: false,
      sortDirection: 'asc',
      baseUrl: baseUrl,
      filter: null,
      modalInfo: { title: '', content: '' }
    }
  },
  mounted () {
    var url = this.baseUrl + 'v1/outriggers/calibrators'
    this.refreshToken()
    var authHeaders = {'Authorization': localStorage.accessToken}
    this.$http.get(url, {headers: authHeaders}, {responseType: 'json', timeout: 10000})
      .then(response => {
        this.items = []
        this.fields = fields
        this.parseResponse(response.body)
      }, response => {
      })
    url = 'https://frb.chimenet.ca/frb-master/v1/outriggers/'
    this.$http.get(url, {headers: authHeaders}, {responseType: 'json', timeout: 10000})
      .then(response => {
        this.items = []
        this.fields = fields
        this.parseOutrigger(response.body)
      }, response => {
      })
  },
  computed: {
    sortOptions () {
      // Create an options list from our fields
      return this.showfields
        .filter(f => f.sortable)
        .map(f => { return { text: f.label, value: f.key } })
    }
  },
  methods: {
    needcheckbox (value) {
      if (value === '') {
        return false
      }
      return true
    },
    parseResponse (schedule) {
      var added = []
      for (var i = 0; i < schedule.length; i++) {
        if (added.includes(schedule[i].name)) {
          continue
        }
        added.push(schedule[i].name)
        var item = {}
        item['name'] = schedule[i].name
        item['beam'] = schedule[i].beam_ids[0]
        item['ra'] = schedule[i].ra
        item['dec'] = schedule[i].dec
        item['unix_utc_start'] = schedule[i].transit_time
        var d = Math.floor(Date.now() / 1000)
        if (item['unix_utc_start'] - d < 300 && item['unix_utc_start'] - d > 0) {
          item['_rowVariant'] = 'danger'
        }
        item['transit_in'] = item['unix_utc_start'] - d
        if (item['transit_in'] >= 0 && item['dec'] > -11) {
          this.items.push(item)
        }
      }
    },
    parseOutrigger (outrigger) {
      this.outriggerItems = outrigger
    },
    resetModal () {
      this.modalInfo.title = ''
      this.modalInfo.content = ''
    },
    showDiagnostics () {
      this.$root.$emit('bv::show::modal', 'modalplots')
    },
    selectParameters () {
      this.$root.$emit('bv::show::modal', 'fieldInfo')
    },
    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Outriggers/vlbi_schedule.vue